import { useNavigate } from 'react-router-dom';

import { deletePoll, unsetSlideType } from '../../../../../db/polls';
import routes from '../../../../../routes/router';
import { usePollContext } from '../../../Context';

const useDeletePoll = () => {
  const { poll } = usePollContext();

  const navigate = useNavigate();

  const handleDeletePollAndRemoveFromSlide = async () => {
    if (!poll?.id) return;

    await unsetSlideType({
      classId: poll.classId,
      activityId: poll.id,
    });

    await deletePoll({
      classId: poll.classId,
      pollId: poll.id,
      toBeDone: poll.toBeDone,
    });

    navigate(routes.home.url(), { replace: true });
  };

  const handleRemoveFromSlide = async () => {
    if (!poll?.id) return;

    await unsetSlideType({
      classId: poll.classId,
      activityId: poll.id,
    });

    navigate(routes.home.url(), { replace: true });
  };

  return { handleDeletePollAndRemoveFromSlide, handleRemoveFromSlide };
};

export default useDeletePoll;
